export default class ErrorHelper {

	static apiHandlerError(error) {
		try {
			if (error.response && error.response.data) {
				return error.response.data;
			}
			return error.message || error;
		} catch (e) {
			return error.message || error;
		}
	}

	static cleanFormErrors(form, formSelector) {
		if (!form && formSelector) {
			form = document.querySelector(formSelector);
		}

		const errorLists = form.querySelectorAll(".ld-alert");
		const mainError = form.parentNode.querySelector("#main-error");

		if (mainError) {
			mainError.remove();
		}

		if (errorLists) {
			errorLists.forEach(erroList => {
				erroList.remove();
			});
		}
	}

	static removeMainError(form) {
		let mainError = form.parentNode.querySelector("#main-error");

		if (mainError) {
			mainError.remove();
		}
	}

	static renderMainFormError(form, errors) {
		let message  = "Ocorreu algum problema, tente novamente mais tarde.";
		const spanElement = document.createElement("span");
		spanElement.classList.add(
			"vs-alert",
			"con-vs-alert-danger",
			"text-danger",
			"text-sm",
			"text-center",
			"w-full",
			"block",
			"my-1",
			"fade-in-top"
		);
		spanElement.setAttribute("id", "main-error");


		if (errors && typeof errors.error == "string") {
			message = errors.error;
		} else if (errors && errors.error && errors.error.message) {
			message = errors.error.message;
		} else if (errors && errors.detail) {
			message = errors.detail;
		}

		spanElement.innerHTML = message;
		form.parentNode.appendChild(spanElement);
	}

	static renderFormError(formSelector, errors) {

		if (!errors) return null;

		const form = document.querySelector(formSelector);

		if (!form) return null;

		ErrorHelper.cleanFormErrors(form);

		if (errors && errors.error) {
			return ErrorHelper.renderMainFormError(form, errors);
		}

		const { fields_errors } = errors;

		if (fields_errors) {

			fields_errors.forEach(field_error => {
				let $inputElement = form[field_error.field];

                    if ($inputElement) {
                        let $inputParentElement = $inputElement.parentNode;

                        if (field_error.errors) {

                            field_error.errors.forEach(error => {

                                const $elementError = document.createElement(
                                    "span"
                                );

                                $elementError.innerHTML = error.message;
                                $elementError.classList.add(
                                    "ld-alert",
                                    "w-full",
                                    "text-left",
									"text-danger",
									"text-sm",
									"pl-1",
									"pt-1"
                                );

                                function removeElementError() {
                                    const $spanError = $inputParentElement.querySelector(".ld-alert");

                                    if ($spanError) {
                                        $spanError.remove();
                                    }

                                    $inputElement.removeEventListener(
                                        "input",
                                        removeElementError
                                    );
                                }

                                if (!error.errors) {
                                    $inputElement.addEventListener(
                                        "input",
                                        removeElementError
                                    );
                                }


                                if (error.errors) {
                                    error.errors.forEach(error => {

                                        if (error.message) {
                                            $elementError.innerHTML = error.message;
                                            $inputParentElement.appendChild($elementError);
                                        }

                                    });

                                } else {
                                    $inputParentElement.appendChild($elementError);
                                }

                            });
                        }
                    }
                });
			} else {
				console.error(errors);
				return ErrorHelper.renderMainFormError(form, errors);
			}

	}
}
